import { render, staticRenderFns } from "./modal-recotized-limits.vue?vue&type=template&id=90048574&"
import script from "./modal-recotized-limits.vue?vue&type=script&lang=js&"
export * from "./modal-recotized-limits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports